// import Header from './Header'
// import CommunityImg from '../Assets/Assests/Community.jpg'
// import Footer from './Footer'

// const Community = () => {
//   return (
//     <>
//       <Header />

//       <div className='min-h-screen' style={{ backgroundColor: '#fff' }}>
//         <header
//           id='home'
//           className='container-fluid py-5'
//           style={{ background: '#fff' }}
//         >
//           <div className='container'>
//             <div
//               className='row align-items-center'
//               style={{
//                 minHeight: '60vh',
//                 marginTop: '30px',
//               }}
//             >
//               <div className='col-lg-6'>
//                 <h1
//                   className='mb-4'
//                   style={{
//                     marginTop: '10px',
//                     fontFamily: 'Inter',
//                     fontWeight: '600',
//                     fontSize: '50px',
//                     color: '#1F3A6A',
//                   }}
//                 >
//                   Community Medicine -
//                   <span
//                     className='mb-4'
//                     style={{
//                       marginTop: '10px',
//                       fontFamily: 'Inter',
//                       fontWeight: '600',
//                       fontSize: '50px',
//                       color: '#889E7E',
//                     }}
//                   >
//                     Bridging Gaps Between Community Medicine and Communities
//                   </span>
//                 </h1>
//               </div>
//               {/* Images */}
//               <div className='col-md-6 d-flex justify-content-center position-relative'>
//                 <div className='position-relative d-none d-md-block'>
//                   <img
//                     src={CommunityImg}
//                     alt='community'
//                     className='img-fluid'
//                     style={{
//                       zIndex: 2,
//                       maxWidth: '90%',
//                       height: 'auto',
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </header>
//         <div className='container py-4'>
//           <div className='mt-2'>
//             Community medicine in India faces several deep-rooted challenges
//             that hinder its effectiveness across both rural and urban
//             populations. While it is designed to prevent diseases, promote
//             health, and involve the community in health planning, the current
//             system suffers from structural, operational, and cultural gaps.
//           </div>
//           <h3 className='fw-bold mt-3 mb-3' style={{ color: '#2D5272' }}>
//             The Challenges:
//           </h3>
//           <div
//             className='container px-5 py-5 mb-5'
//             style={{
//               backgroundColor: '#EAFAEF',
//               width: '1005',
//               height: '1635',
//               top: '683px',
//               left: '253px',
//               borderRadius: '20px',
//             }}
//           >
//             <p
//               className='mt-2 mb-2'
//               style={{
//                 fontFamily: 'Inter',
//                 fontWeight: '500',
//                 fontSize: '17px',
//               }}
//             >
//               <ol
//                 style={{
//                   lineHeight: '25px',
//                   letterSpacing: '0%',
//                 }}
//               >
//                 <li className='mb-3'>
//                   <b>Limited Reach in Rural Areas:</b> Many villages lack basic
//                   healthcare infrastructure, and community medicine fails to
//                   penetrate these areas consistently due to poor logistics and
//                   resource allocation.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Urban Gaps in Lifestyle Care:</b> Urban populations face
//                   rising non-communicable diseases like diabetes, hypertension,
//                   and mental health disorders, but community medicine programs
//                   rarely address these issues effectively.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Hospital-Centric Healthcare:</b> Most public and private
//                   hospitals focus on curative care, not prevention or community
//                   outreach, leaving a major gap in continuous health engagement.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Weak Public Awareness:</b> There’s a significant lack of
//                   health education among citizens about hygiene, nutrition, and
//                   disease prevention.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Minimal Community Involvement:</b> Programs are often
//                   top-down, with little engagement from the community in
//                   identifying local needs or solutions.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Fragmented Governance:</b> Health departments and local
//                   governments often operate in silos, with poor coordination
//                   between hospitals, public health centers, and municipal
//                   agencies.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Underutilized Health Workers:</b> ASHAs and Anganwadi
//                   workers are overburdened and undertrained, limiting their
//                   capacity to conduct effective health outreach.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Lack of Real-Time Data:</b> There is no dynamic data system
//                   to track community-level health trends, outbreaks, or
//                   behavioral patterns.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Ineffective Urban Health Missions:</b> Urban Health
//                   Missions struggle with resource constraints and poorly
//                   targeted programs.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Generic Health Campaigns:</b> Health programs are rarely
//                   tailored to the unique sociocultural and linguistic contexts
//                   of each region.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Mental Health Neglected:</b> Community mental health
//                   support is almost non-existent, both in rural and urban India,
//                   despite rising stress and anxiety.
//                 </li>
//                 <li className='mb-3'>
//                   <b>School and College Engagement Missing:</b> There is limited
//                   integration of community medicine with educational
//                   institutions, missing a key opportunity to influence youth.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Lack of Digital Innovation:</b> Community medicine has not
//                   yet embraced AI, telemedicine, or mobile health apps to scale
//                   outreach or personalize care.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Low Trust in Public Services:</b> In many regions, people
//                   distrust government health workers, preferring private or
//                   traditional alternatives.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Overmedicalization in Hospitals: </b>Hospitals tend to
//                   focus on diagnosis and treatment, neglecting follow-ups,
//                   prevention, and social determinants of health.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Funding and Policy Gaps:</b> Investment in community health
//                   remains low compared to hospital infrastructure and high-end
//                   medical technology.
//                 </li>
//                 <li className='mb-3'>
//                   <b>No Continuity of Care:</b> There’s a disjoint between
//                   community-based efforts and tertiary care, with no feedback
//                   loop or follow-up system.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Crisis-Driven Response:</b> Community medicine often
//                   activates during epidemics but lacks a sustainable, year-round
//                   presence.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Low Health Literacy:</b> The general population often
//                   cannot understand health information, prescriptions, or
//                   preventive advice.
//                 </li>
//                 <li className='mb-3'>
//                   <b>Missed SDG Opportunities:</b> Community medicine fails to
//                   fully align with Sustainable Development Goals, missing the
//                   chance to improve health, well-being, and gender equity at the
//                   grassroots level.
//                 </li>
//               </ol>
//               <p>
//                 A comprehensive reform in mindset, training, technology
//                 integration, and public participation is essential to transform
//                 community medicine from a peripheral function to a central
//                 pillar of India’s healthcare system.
//               </p>
//             </p>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   )
// }

// export default Community

import Header from './Header'
import CommunityImg from '../Assets/Assests/Community.jpg'
import Footer from './Footer'

const Community = () => {
  return (
    <>
      <Header />

      <div className='min-vh-100' style={{ backgroundColor: '#fff' }}>
        {/* Hero Section */}
        <header
          id='home'
          className='container-fluid py-4 py-md-5'
          style={{ background: '#fff' }}
        >
          <div className='container'>
            <div
              className='row align-items-center g-4'
              style={{
                minHeight: '60vh',
                marginTop: '30px',
              }}
            >
              <div className='col-12 col-lg-6 order-2 order-lg-1'>
                <h1
                  className='mb-3 mb-md-4 text-center text-lg-start'
                  style={{
                    marginTop: '10px',
                    fontFamily: 'Inter',
                    fontWeight: '600',
                    fontSize: 'clamp(1.8rem, 6vw, 3.2rem)',
                    color: '#1F3A6A',
                    lineHeight: '1.2',
                  }}
                >
                  Community Medicine -
                  <span
                    className='d-block mt-2'
                    style={{
                      fontFamily: 'Inter',
                      fontWeight: '600',
                      fontSize: 'clamp(1.8rem, 6vw, 3.2rem)',
                      color: '#889E7E',
                    }}
                  >
                    Bridging Gaps Between Community Medicine and Communities
                  </span>
                </h1>
              </div>

              {/* Images */}
              <div className='col-12 col-lg-6 d-flex justify-content-center position-relative order-1 order-lg-2'>
                <div className='position-relative'>
                  <img
                    src={CommunityImg || '/placeholder.svg'}
                    alt='community'
                    className='img-fluid rounded'
                    style={{
                      zIndex: 2,
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Content Section */}
        <div className='container py-4 py-md-5'>
          <div className='mt-2'>
            <p
              className='mt-2 mb-4 text-center text-lg-start'
              style={{
                fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
                lineHeight: '1.6',
                color: '#333',
              }}
            >
              Community medicine in India faces several deep-rooted challenges
              that hinder its effectiveness across both rural and urban
              populations. While it is designed to prevent diseases, promote
              health, and involve the community in health planning, the current
              system suffers from structural, operational, and cultural gaps.
            </p>

            <h3
              className='fw-bold mt-4 mb-3 mb-md-4 text-center text-lg-start'
              style={{
                color: '#2D5272',
                fontSize: 'clamp(1.3rem, 3vw, 1.8rem)',
              }}
            >
              The Challenges:
            </h3>

            {/* Challenges Section */}
            <div
              className='px-3 px-md-4 px-lg-5 py-4 py-md-5 mb-4 mb-md-5'
              style={{
                backgroundColor: '#EAFAEF',
                borderRadius: '20px',
              }}
            >
              <div
                style={{
                  fontFamily: 'Inter',
                  fontWeight: '500',
                  fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                  lineHeight: '1.6',
                }}
              >
                <ol
                  className='ps-3 ps-md-4'
                  style={{
                    lineHeight: '1.8',
                    letterSpacing: '0%',
                  }}
                >
                  <li className='mb-3'>
                    <strong>Limited Reach in Rural Areas:</strong> Many villages
                    lack basic healthcare infrastructure, and community medicine
                    fails to penetrate these areas consistently due to poor
                    logistics and resource allocation.
                  </li>
                  <li className='mb-3'>
                    <strong>Urban Gaps in Lifestyle Care:</strong> Urban
                    populations face rising non-communicable diseases like
                    diabetes, hypertension, and mental health disorders, but
                    community medicine programs rarely address these issues
                    effectively.
                  </li>
                  <li className='mb-3'>
                    <strong>Hospital-Centric Healthcare:</strong> Most public
                    and private hospitals focus on curative care, not prevention
                    or community outreach, leaving a major gap in continuous
                    health engagement.
                  </li>
                  <li className='mb-3'>
                    <strong>Weak Public Awareness:</strong> There's a
                    significant lack of health education among citizens about
                    hygiene, nutrition, and disease prevention.
                  </li>
                  <li className='mb-3'>
                    <strong>Minimal Community Involvement:</strong> Programs are
                    often top-down, with little engagement from the community in
                    identifying local needs or solutions.
                  </li>
                  <li className='mb-3'>
                    <strong>Fragmented Governance:</strong> Health departments
                    and local governments often operate in silos, with poor
                    coordination between hospitals, public health centers, and
                    municipal agencies.
                  </li>
                  <li className='mb-3'>
                    <strong>Underutilized Health Workers:</strong> ASHAs and
                    Anganwadi workers are overburdened and undertrained,
                    limiting their capacity to conduct effective health
                    outreach.
                  </li>
                  <li className='mb-3'>
                    <strong>Lack of Real-Time Data:</strong> There is no dynamic
                    data system to track community-level health trends,
                    outbreaks, or behavioral patterns.
                  </li>
                  <li className='mb-3'>
                    <strong>Ineffective Urban Health Missions:</strong> Urban
                    Health Missions struggle with resource constraints and
                    poorly targeted programs.
                  </li>
                  <li className='mb-3'>
                    <strong>Generic Health Campaigns:</strong> Health programs
                    are rarely tailored to the unique sociocultural and
                    linguistic contexts of each region.
                  </li>
                  <li className='mb-3'>
                    <strong>Mental Health Neglected:</strong> Community mental
                    health support is almost non-existent, both in rural and
                    urban India, despite rising stress and anxiety.
                  </li>
                  <li className='mb-3'>
                    <strong>School and College Engagement Missing:</strong>{' '}
                    There is limited integration of community medicine with
                    educational institutions, missing a key opportunity to
                    influence youth.
                  </li>
                  <li className='mb-3'>
                    <strong>Lack of Digital Innovation:</strong> Community
                    medicine has not yet embraced AI, telemedicine, or mobile
                    health apps to scale outreach or personalize care.
                  </li>
                  <li className='mb-3'>
                    <strong>Low Trust in Public Services:</strong> In many
                    regions, people distrust government health workers,
                    preferring private or traditional alternatives.
                  </li>
                  <li className='mb-3'>
                    <strong>Overmedicalization in Hospitals:</strong> Hospitals
                    tend to focus on diagnosis and treatment, neglecting
                    follow-ups, prevention, and social determinants of health.
                  </li>
                  <li className='mb-3'>
                    <strong>Funding and Policy Gaps:</strong> Investment in
                    community health remains low compared to hospital
                    infrastructure and high-end medical technology.
                  </li>
                  <li className='mb-3'>
                    <strong>No Continuity of Care:</strong> There's a disjoint
                    between community-based efforts and tertiary care, with no
                    feedback loop or follow-up system.
                  </li>
                  <li className='mb-3'>
                    <strong>Crisis-Driven Response:</strong> Community medicine
                    often activates during epidemics but lacks a sustainable,
                    year-round presence.
                  </li>
                  <li className='mb-3'>
                    <strong>Low Health Literacy:</strong> The general population
                    often cannot understand health information, prescriptions,
                    or preventive advice.
                  </li>
                  <li className='mb-3'>
                    <strong>Missed SDG Opportunities:</strong> Community
                    medicine fails to fully align with Sustainable Development
                    Goals, missing the chance to improve health, well-being, and
                    gender equity at the grassroots level.
                  </li>
                </ol>

                <p
                  className='mt-4 mb-0 text-center text-lg-start'
                  style={{
                    fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                    lineHeight: '1.6',
                    fontWeight: '500',
                  }}
                >
                  A comprehensive reform in mindset, training, technology
                  integration, and public participation is essential to
                  transform community medicine from a peripheral function to a
                  central pillar of India's healthcare system.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default Community
